import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetRiesgoEmbarazoLactanciaByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetRiesgoEmbarazoLactanciaByUser = () => {
  const [loadingGetRiesgoEmbarazoLactanciaByUser, setLoadingGetRiesgoEmbarazoLactanciaByUser] = useState(false);
  const [successGetRiesgoEmbarazoLactanciaByUser, setSuccessGetRiesgoEmbarazoLactanciaByUser] = useState(false);
  const [errorGetRiesgoEmbarazoLactanciaByUser, setErrorGetRiesgoEmbarazoLactanciaByUser] = useState<any>(null);
  const [dataGetRiesgoEmbarazoLactanciaByUser, setDataRiesgoEmbarazoLactanciaByUser] = useState<any>(null);

  const [statusGetRiesgoEmbarazoLactanciaByUser, setStatusGetRiesgoEmbarazoLactanciaByUser] =
    useState<StatusGetRiesgoEmbarazoLactanciaByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getRiesgoEmbarazoLactanciaByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetRiesgoEmbarazoLactanciaByUser(true);
    setSuccessGetRiesgoEmbarazoLactanciaByUser(false);
    setErrorGetRiesgoEmbarazoLactanciaByUser(null);

    try {
      const res = await apirecord.getSolicitudReconocimientoRELByUser(userId, expedienteId);

      setStatusGetRiesgoEmbarazoLactanciaByUser({
        status: res.status,
        statusText: res.response
      });

      setSuccessGetRiesgoEmbarazoLactanciaByUser(true);
      setDataRiesgoEmbarazoLactanciaByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const backendMessage =
        err?.response?.data?.response ||
        err?.response?.data?.message ||
        err?.message ||
        "Error";

      setStatusGetRiesgoEmbarazoLactanciaByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetRiesgoEmbarazoLactanciaByUser(err);
      console.error("Error en getRiesgoEmbarazoLactanciaByUser:", err);

      throw err;

    } finally {
      setLoadingGetRiesgoEmbarazoLactanciaByUser(false);
    }
  };

  return {
    getRiesgoEmbarazoLactanciaByUser,
    loadingGetRiesgoEmbarazoLactanciaByUser,
    successGetRiesgoEmbarazoLactanciaByUser,
    errorGetRiesgoEmbarazoLactanciaByUser,
    dataGetRiesgoEmbarazoLactanciaByUser,
    statusGetRiesgoEmbarazoLactanciaByUser
  };
};

export default useGetRiesgoEmbarazoLactanciaByUser;
